module.exports = __webpack_public_path__ + "static/img/label-icon2-en.801eb451.png";